import { c as _c } from "react/compiler-runtime";
import ClassifyDivider from '@classify/react-core-components/Divider';
import { styled } from '@classify/react-core-components/styles';
const PREFIX = 'Divider';
const classes = {
  dividerRoot: `${PREFIX}-dividerRoot`
};
const StyledClassifyDivider = styled(ClassifyDivider)(/* istanbul ignore next */({
  theme: {
    spacing
  }
}) => ({
  [`& .${classes.dividerRoot}`]: {
    margin: spacing(1, 0)
  }
}));
const Divider = () => {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <StyledClassifyDivider classes={{
      root: classes.dividerRoot
    }} />;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
};
export default Divider;